export default "__VITE_ASSET__DPSnJYpz__"